import React from 'react'

import Footer from './Footer'
import avatar from '../assets/images/avatar.jpg'

const Header = () => (
  <header id="header">
    <div className="inner">
      <div className="image avatar">
        <img src={avatar} alt="" />
      </div>
      <h1>
        <strong>Hi,I am Ajay Jangid</strong>,
        <br />
        Software Developer | Blogger
        <br />
        Founded <a href='https://developerstacks.com/'>Developer Stacks</a>
        <br/>
        
      </h1>
    </div>
    <Footer />
  </header>
)

export default Header